import SEO_PAGES from "./seoPages.json";
import { getPostBySlug } from "../content/blog";

export const SEO_BY_PATH = SEO_PAGES;

export const getSeoForPath = (pathname) => {
  const path = pathname || "/";
  const normalized = path.length > 1 ? path.replace(/\/$/, "") : path;

  if (normalized === "/blog") {
    return SEO_BY_PATH.find((item) => item.path === "/blog") || SEO_BY_PATH[0];
  }

  if (normalized.startsWith("/blog/")) {
    const slug = normalized.slice("/blog/".length);
    const post = getPostBySlug(slug);
    if (!post) {
      return {
        path: normalized,
        title: "Post not found",
        description: "This Treasure blog post could not be found.",
        noindex: true,
      };
    }
    return {
      path: `/blog/${post.slug}`,
      title: post.title,
      description: post.description,
      type: "article",
      image: post.ogImage || "/covers/treasure-16-9.jpg",
      imageAlt: post.title,
      publishedTime: post.date,
      modifiedTime: post.updated || post.date,
      keywords: [post.focusKeyword, ...(post.tags || [])].filter(Boolean).join(", "),
    };
  }

  const exact = SEO_BY_PATH.find((item) => item.path === normalized);
  if (exact) return exact;

  const prefix = SEO_BY_PATH.find((item) => normalized.startsWith(item.path) && item.path !== "/");
  return prefix || SEO_BY_PATH[0];
};
